module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trackings) ? _c('div', {
    staticClass: "tracking-table"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', {
    staticClass: "tracking-date"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_time')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-kit"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_kit')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-activity"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_activity')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-kit-activity"
  }, [_vm._v(_vm._s(_vm.$t('statistics.kit_and_activity')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-hint"
  })]), _vm._v(" "), _vm._l((_vm.trackings), function(tracking) {
    return _c('tr', {
      key: tracking.id,
      class: 'tracking-list-' + tracking.id
    }, [_c('td', {
      staticClass: "tracking-date"
    }, [_vm._v(_vm._s(_vm.date(tracking.time)))]), _vm._v(" "), _c('td', {
      staticClass: "tracking-kit"
    }, [_vm._v(_vm._s(tracking.event_name))]), _vm._v(" "), _c('td', {
      staticClass: "tracking-activity"
    }, [_vm._v(_vm._s(tracking.advertisement_name) + " " + _vm._s(_vm.$t('models.tracking.specific.' + tracking.name)) + " "), (tracking.referrer_url) ? _c('a', {
      staticClass: "icon icon-external-link",
      attrs: {
        "href": tracking.referrer_url,
        "target": "_blank"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "tracking-kit-activity"
    }, [_vm._v("\n        " + _vm._s(tracking.event_name)), (tracking.event_name) ? _c('br') : _vm._e(), _vm._v("\n        " + _vm._s(tracking.advertisement_name) + " " + _vm._s(_vm.$t('models.tracking.specific.' + tracking.name)) + " "), (tracking.referrer_url) ? _c('a', {
      staticClass: "icon icon-external-link",
      attrs: {
        "href": tracking.referrer_url,
        "target": "_blank"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "tracking-hint"
    }, [_c('div', {
      staticClass: "hint"
    }, [_c('i', {
      staticClass: "icon icon-info trigger"
    }), _vm._v(" "), _c('div', {
      staticClass: "hint-content"
    }, [_c('p', [_c('i', {
      staticClass: "icon icon-map-pin"
    }), _vm._v("\n              " + _vm._s(tracking.city) + "\n            ")]), _vm._v(" "), _c('p', [_c('i', {
      staticClass: "icon icon-monitor"
    }), _vm._v("\n              " + _vm._s(tracking.browser) + " | " + _vm._s(tracking.os) + "\n            ")])])])])])
  })], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25db670a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/TrackingTable.vue
// module id = 1844
// module chunks = 0